import { Context } from 'vm';
import { Commit, Store } from 'vuex'
import { http } from "../../plugins/axios";

export interface BenefitsState {
    benefits: Array<any>,
    benefitTypes: string[]
}

const state = (): BenefitsState => ({
    benefits: [],
    benefitTypes: []
});

const mutations = {
    'STORE_BENEFITS'(state: BenefitsState, benefits: any) {
        state.benefits = benefits
    },
    'STORE_BENEFIT_TYPES'(state:BenefitsState, benefitTypes: string[]) {
        state.benefitTypes = benefitTypes
    }
};

const getters = {
    getBenefits(state: BenefitsState) {
        return state.benefits
    },
    getBenefitTypes(state: BenefitsState) {
        return state.benefitTypes
    }
};

const actions = {
    async getBenefits({ commit }: {commit: Commit}, payload: any) {
        const endpoint = `benefits`
        const res = await http.get(endpoint, {
            params: payload
        })

        commit('STORE_BENEFITS', res.data.benefits)

        return true
    },
    async getBenefitTypes({ commit }: {commit: Commit}) {
        const endpoint = `benefits-types`
        const res = await http.get(endpoint)

        commit('STORE_BENEFIT_TYPES', res.data.benefits_types)

        return true
    },
    async getBenefitPayments(_ctx: any, benefitId: number) {
        const endpoint = `benefit/${benefitId}/payments`
        const res = await http.get(endpoint)

        return res.data
    },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
